const BASE_URL = process.env.REACT_APP_BACKEND_URI

export default BASE_URL